var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1685_30485)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1685_30485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8091 8.45988C19.8091 9.89549 19.2388 11.2723 18.2237 12.2874C17.2086 13.3026 15.8317 13.8729 14.3961 13.8729C12.9605 13.8729 11.5837 13.3026 10.5686 12.2874C9.55342 11.2723 8.98313 9.89549 8.98313 8.45988C8.98313 7.02426 9.55342 5.64744 10.5686 4.63231C11.5837 3.61717 12.9605 3.04688 14.3961 3.04688C15.8317 3.04688 17.2086 3.61717 18.2237 4.63231C19.2388 5.64744 19.8091 7.02426 19.8091 8.45988ZM7.36613 15.2259C5.93051 15.2259 4.55369 15.7962 3.53856 16.8113C2.52342 17.8264 1.95313 19.2033 1.95312 20.6389C1.95313 22.0745 2.52342 23.4513 3.53856 24.4664C4.55369 25.4816 5.93051 26.0519 7.36613 26.0519C8.80174 26.0519 10.1786 25.4816 11.1937 24.4664C12.2088 23.4513 12.7791 22.0745 12.7791 20.6389C12.7791 19.2033 12.2088 17.8264 11.1937 16.8113C10.1786 15.7962 8.80174 15.2259 7.36613 15.2259ZM21.4281 15.2259C20.7172 15.2257 20.0133 15.3657 19.3565 15.6376C18.6997 15.9096 18.1029 16.3083 17.6003 16.811C17.0976 17.3137 16.6989 17.9105 16.4269 18.5673C16.1549 19.224 16.015 19.928 16.0151 20.6389C16.0151 22.0746 16.5855 23.4516 17.6007 24.4668C18.6159 25.482 19.9929 26.0524 21.4286 26.0524C22.8644 26.0524 24.2413 25.482 25.2565 24.4668C26.2718 23.4516 26.8421 22.0746 26.8421 20.6389C26.8423 19.9279 26.7023 19.2239 26.4303 18.567C26.1582 17.9102 25.7594 17.3133 25.2566 16.8107C24.7539 16.308 24.157 15.9093 23.5001 15.6374C22.8431 15.3654 22.1391 15.2256 21.4281 15.2259Z",
    fill: "#F06A6A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1685_30485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.398438 0.5625)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1685_30485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.398438 0.5625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsana);
export default __webpack_public_path__ + "static/media/asana.e11e6322085c5e0f9aad723a7537626f.svg";
export { ForwardRef as ReactComponent };